import clsx from 'clsx';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import AppointmentReminder from '../../../Components/General/AppointmentReminder';
import CommonCard from '../../../Components/General/CommonCard';
import NoDataFound from '../../../Components/General/NoDataFound';
import PackageCard from '../../../Components/General/PackageCard';
import PackagePendingCard from '../../../Components/General/PackagePendingCard';
import Pagination from '../../../Components/General/Pagination';
import PaginationWrapper from '../../../Components/General/PaginationWrapper';
import SelectedPackageCard from '../../../Components/General/SelectedPackageCard';
import SMSPackageDetailCard from '../../../Components/General/SMSPackageDetailCard';
import RadioButton from '../../../Components/UI/RadioButton';
import ToggleButton from '../../../Components/UI/ToggleButton';
import { smsSettingListing } from '../../../data';
import PaymentMethodDrawer from '../../../Drawer/PaymentMethodDrawer';
import useProfile from '../../../Features/useProfile';
import { checkDatePassed } from '../../../Helpers';
import AlertModal from '../../../Modals/AlertModal';
import { setSettingsData } from '../../../Store/authSlice';
import classes from './SmsPage.module.css';
const controlAllSmsSetting = (value = false) => {
  return {
    smsIsAuto: value,
    smsIsInvoice: value,
    smsIsPrescription: value,
    smsIsCreationOfAppointment: value,
    smsIsRescheduleOfAppointment: value,
    smsIsCancellationOfAppointment: value,
    smsIsAppointmentReminder: value,
    smsAppointmentReminderTime: '1-H',
    smsIsIncludeDoctorNumber: value,
    smsIsIncludePaNumber: value
  };
};
const SMSPage = ({
  smsPackagesList,
  onAddSmsSubscription,
  subscriptionList,
  onCancelRequest,
  loading,
  getSmsSubscription
}) => {
  const dispatch = useDispatch();
  const { updateSmsControl, loading: smsLoading } = useProfile();
  const smsSettings = useSelector((state) => state?.authReducer?.settingsData);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [showAreYouCancelSubscriptionRequest, setShowAreYouCancelSubscriptionRequest] =
    useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showPaymentMethodDrawer, setShowPaymentMethodDrawer] = useState(false);
  const togglePaymentMethodDrawer = () => {
    setShowPaymentMethodDrawer((current) => !current);
  };
  const [selectedPendingSubscription, setSelectedPendingSubscription] = useState(null);
  const pendingSubscriptionList = subscriptionList?.data?.filter(
    (data) => data?.isPaid === false && data?.isCancelled === false
  );
  // Define the time zone (e.g., 'America/New_York')
  const selectedPackageList = subscriptionList?.data?.filter(
    (data) =>
      data?.isPaid && checkDatePassed(data?.subscriptionStartDate, data?.subscriptionEndDate)
  );

  const drawSubscriptionHistory = subscriptionList?.data?.filter(
    (data) =>
      !checkDatePassed(data?.subscriptionStartDate, data?.subscriptionEndDate) && data?.isPaid
  );

  return (
    <>
      <section className={classes.pageWrapper}>
        <Row>
          {smsPackagesList?.map((data, index) => (
            <PackageCard
              setter={() => {
                setSelectedPackage(data?.packageID);

                togglePaymentMethodDrawer();
              }}
              markSelected={selectedPackage === data?.packageID}
              data={data}
              headerCard={data?.packageName?.startsWith('Standard')}
            />
          ))}
        </Row>
      </section>
      <section>
        <Row>
          <Col md={5}>
            <CommonCard className={classes.bgWhite}>
              <ul className={clsx(classes.packagePendingWrapper, 'scrollbar1')}>
                {pendingSubscriptionList?.map((data) => (
                  <li key={data?.rowNum}>
                    <PackagePendingCard
                      data={data}
                      onCancelRequest={() => {
                        setSelectedPendingSubscription(data);
                        setShowAreYouCancelSubscriptionRequest(true);
                      }}
                    />
                    <div className={classes.toggleBlock}></div>
                  </li>
                ))}
              </ul>

              <ul className={classes.selectedPackageWrapper}>
                {selectedPackageList?.map((data) => {
                  <li key={data?.rowNum}>
                    <SelectedPackageCard data={data} />
                  </li>;
                })}
              </ul>

              <div className={classes.smsSettingWrapper}>
                <div className={classes.headerAction}>
                  <h3>Send Auto SMS</h3>
                  <span>
                    <ToggleButton
                      loading={smsLoading}
                      value={smsSettings?.smsIsAuto}
                      setter={(e) => {
                        updateSmsControl(
                          {
                            ...smsSettings,
                            smsIsAuto: e
                          },
                          () => {
                            dispatch(
                              setSettingsData({
                                ...smsSettingListing,
                                ...controlAllSmsSetting(e)
                              })
                            );
                          }
                        );
                      }}
                    />
                  </span>
                </div>

                <ul className={classes.allSettingsList}>
                  {smsSettingListing?.map((element) => {
                    return (
                      <li className={classes.settingCard}>
                        <div className={classes.toggleBtnWrapper}>
                          <p className={classes.settingLabel}>{element?.label}</p>
                          <ToggleButton
                            disabled={smsLoading}
                            value={smsSettings[element?.key]}
                            setter={(e) => {
                              updateSmsControl(
                                {
                                  ...smsSettings,
                                  [element?.key]: e
                                },
                                () => {
                                  dispatch(
                                    setSettingsData({
                                      ...smsSettings,
                                      [element?.key]: e
                                    })
                                  );

                                  if (!e) {
                                    dispatch(
                                      setSettingsData({
                                        ...smsSettings,
                                        [element?.key]: e,
                                        smsIsAuto: false
                                      })
                                    );
                                  }
                                }
                              );
                            }}
                          />
                        </div>
                        {element?.key === 'smsIsAppointmentReminder' &&
                          smsSettings?.smsIsAppointmentReminder && (
                            <AppointmentReminder
                              onSubmit={(e, onSuccess) => {
                                updateSmsControl(
                                  {
                                    ...smsSettings,
                                    smsAppointmentReminderTime: e
                                  },
                                  () => {
                                    dispatch(
                                      setSettingsData({
                                        ...smsSettings,
                                        smsAppointmentReminderTime: e
                                      })
                                    );
                                  }
                                );
                              }}
                            />
                          )}
                      </li>
                    );
                  })}
                </ul>
                <h3>Phone Number</h3>
                <ul className={classes.stakeHolderList}>
                  <li className={classes.stakeHolderCard}>
                    <RadioButton
                      label={'Dr. [Name]'}
                      name={'select-stakeHolder'}
                      value={smsSettings?.smsIsIncludeDoctorNumber}
                      selected={smsSettings?.smsIsIncludeDoctorNumber}
                      id={'doctor-package'}
                      disabled={loading}
                      setter={(e) => {
                        updateSmsControl(
                          {
                            ...smsSettings,
                            smsIsIncludeDoctorNumber: true,
                            smsIsIncludePaNumber: false
                          },
                          () => {
                            dispatch(
                              setSettingsData({
                                ...smsSettings,
                                smsIsIncludeDoctorNumber: true,
                                smsIsIncludePaNumber: false
                              })
                            );
                          }
                        );
                      }}
                    />
                    <p className={classes.stakeHolderCellNumber}>0333 1234 567</p>
                  </li>

                  <li className={classes.stakeHolderCard}>
                    <RadioButton
                      label={'[PA Name]'}
                      name={'select-stakeHolder'}
                      value={smsSettings?.smsIsIncludePaNumber}
                      id={'pa-package'}
                      selected={smsSettings?.smsIsIncludePaNumber}
                      disabled={loading}
                      setter={(e) => {
                        updateSmsControl(
                          {
                            ...smsSettings,
                            smsIsIncludePaNumber: true,
                            smsIsIncludeDoctorNumber: false
                          },
                          () => {
                            dispatch(
                              setSettingsData({
                                ...smsSettings,
                                smsIsIncludePaNumber: true,
                                smsIsIncludeDoctorNumber: false
                              })
                            );
                          }
                        );
                      }}
                    />
                    <p className={classes.stakeHolderCellNumber}>0333 1234 567</p>
                  </li>
                </ul>
              </div>
            </CommonCard>
          </Col>
          <Col md={7}>
            <CommonCard className={classes.bgWhite}>
              <h2 className={classes.historyTitle}>SMS History</h2>
              <Row>
                {drawSubscriptionHistory?.length > 0 ? (
                  drawSubscriptionHistory?.map((data) => (
                    <Col md={6} className={classes.smsPackageCardWrapper}>
                      <SMSPackageDetailCard data={data} />
                    </Col>
                  ))
                ) : (
                  <NoDataFound label="No Subscription History Found" />
                )}
              </Row>
              <footer>
                <PaginationWrapper>
                  <Pagination
                    limit={10}
                    totalCount={totalCount}
                    page={page}
                    setPage={(e) => {
                      setPage(e);
                      getSmsSubscription(e);
                    }}
                  />
                </PaginationWrapper>
              </footer>
            </CommonCard>
          </Col>
        </Row>
      </section>
      <PaymentMethodDrawer
        setSelectedPackage={setSelectedPackage}
        data={selectedPackage}
        show={showPaymentMethodDrawer}
        setShow={togglePaymentMethodDrawer}
        onSubmit={onAddSmsSubscription}
      />
      {showAreYouCancelSubscriptionRequest && (
        <AlertModal
          loading={loading}
          title={'Delete Service'}
          content={
            <span>
              Are you sure you want to cancel subscription request{' '}
              <span className={classes.contentName}>
                {selectedPendingSubscription?.serviceName}{' '}
              </span>
            </span>
          }
          onConfirm={() =>
            onCancelRequest({ subscriptionId: selectedPendingSubscription?.subscriptionID }, () => {
              setSelectedPendingSubscription(null);
              setShowAreYouCancelSubscriptionRequest();
            })
          }
          show={showAreYouCancelSubscriptionRequest}
          setShow={setShowAreYouCancelSubscriptionRequest}
        />
      )}
    </>
  );
};

export default SMSPage;
